/* Sorting
 *
 * - Public API
 *   - order from public api documentation
 * - Internal API
 *   - order from internal api documentation
 * - Undocumented API
 *   - order alphabetically
 */

export enum NinchatEventCause {
    // Public API
    NinchatAudienceAcceptPeerEventCause = 'audience_accept_peer',
    NinchatAudienceAcceptSelfEventCause = 'audience_accept_self',
    NinchatAudienceDropEventCause = 'audience_drop',
    NinchatAudienceRequestEventCause = 'audience_request',
    NinchatChannelScheduleEventCause = 'channel_schedule',
    NinchatChannelUpdateEventCause = 'channel_update',
    NinchatMemberRemoveEventCause = 'member_remove',
    NinchatPaymentSubscriptionExpireEventCause = 'payment_subscription_expire',
    NinchatQueueScheduleEventCause = 'queue_schedule',
    NinchatQueueUpdateEventCause = 'queue_update',
}

// vim:foldmethod=syntax

